"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { orbitShellMinHeight } from "@/lib/orbit-layout";
import type { Post } from "@/lib/posts";

const BlogOrbitDesktopInner = dynamic(
  () => import("./BlogOrbitDesktopInner").then((m) => ({ default: m.BlogOrbitDesktopInner })),
  { ssr: false, loading: () => null },
);

const DESKTOP_MQ = "(min-width: 861px)";

/** 3D orbit — desktop only. Shell reserves height on SSR to avoid CLS. */
export function BlogOrbitDesktop({
  posts,
  lcpSrc,
  bootId,
}: {
  posts: Post[];
  lcpSrc?: string;
  bootId: string;
}) {
  const [loadOrbit, setLoadOrbit] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(DESKTOP_MQ);
    const update = () => setLoadOrbit(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return (
    <div
      className="blog-orbit-shell blog-orbit-shell--desktop"
      style={{ minHeight: orbitShellMinHeight(posts.length) }}
    >
      {lcpSrc ? (
        <div
          id={bootId}
          className="blog-orbit-boot"
          role="status"
          aria-live="polite"
          aria-label="Loading blog posts"
          aria-busy={!loadOrbit}
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={lcpSrc}
            alt=""
            className="blog-orbit-boot-img"
            width={200}
            height={125}
            fetchPriority="high"
            decoding="async"
          />
          <span className="blog-orbit-spinner" aria-hidden />
          <p className="blog-orbit-loading-label">Loading posts</p>
        </div>
      ) : null}
      {loadOrbit ? (
        <BlogOrbitDesktopInner posts={posts} bootId={bootId} />
      ) : null}
    </div>
  );
}
